/**
 * Configuration types.
 */
export enum ConfigurationTypes {
    SPINE_ANIMATIONS = "spine_animation",
    SYMBOL_SPINE_ANIMATIONS = "symbol_spine_animation",
    WIN_SYMBOL_SPINE_ANIMATIONS = "win_symbol_spine_animation",
    BUY_FEATURE = "buy_feature",
    BET = "bet",
    SETTINGS = "settings",
    GAME = "game",
    LOCAL = "local",
    RELAX_SERVER = "relax_server",
}
